<script setup lang="ts">
const { color = 'yellow', size = 'm' } = defineProps<{
  color?: 'yellow' | 'white';
  size?: 's' | 'm' | 'l' | 'xl';
}>();
</script>

<template>
  <div
    class="ui-spinner public-spinner"
    :class="[`_color-${color}`, `_size-${size}`]"
  />
</template>
